import { defineNuxtPlugin } from '#app/nuxt'
import { LazyNuxtLink } from '#components'
const lazyGlobalComponents = [
  ["NuxtLink", LazyNuxtLink],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
